<template>
    <div class="card shadow-sm h-100 photo-tile photo-tile-document">
        <div class="photo-tile-thumb" title="Zvětšit" @click="$emit('open')">
            <img :src="attachment.url" :alt="attachment.type" loading="lazy">
        </div>
        <div class="card-body p-2 d-flex align-items-center">
            <span class="small text-muted me-auto">{{ order }}.</span>
            <button type="button" class="btn btn-sm btn-link text-secondary px-1" title="Zvětšit" @click="$emit('open')">
                <span class="fas fa-search-plus"></span>
            </button>
            <button type="button" class="btn btn-sm btn-link text-danger px-1" title="Smazat" @click="$emit('remove')">
                <span class="fas fa-trash"></span>
            </button>
        </div>
    </div>
</template>

<script lang="ts">
import {Attachment} from '@/model/api';
import {defineComponent, PropType} from 'vue';

export default defineComponent({
    name: 'AttachmentControl',

    props: {
        attachment: {type: Object as PropType<Attachment>, required: true},
        order: {type: Number, required: true},
    },

    emits: ['open', 'remove'],
});
</script>
